import axios from 'axios';
import moment from 'moment';
import React, { Component } from 'react';
import { Button, Spinner, Table, Row, Col, Dropdown, Card, Modal } from 'react-bootstrap';
import { connect } from 'react-redux';
import { toast } from 'react-toastify';
import { t } from '../../helpers/translation_helper';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowUpRightFromSquare, faBook, faGlobe } from '@fortawesome/free-solid-svg-icons';
import { Link } from 'react-router-dom';
import { Black, Blueberry, BlueCrayola, CerisePink, ChristmasWhite, FrenchRose, LightGray, SeashellPink, White } from '../../helpers/brand_colors_helper';
import { GET } from '../../api';
import GetIcon from '../../helpers/icon_helper';
import TimetableComplete from '../TimetableComplete/_TimetableComplete';
const ContrastColor = require('contrast-color');

// API URL
const apiURL = process.env.REACT_APP_API_URL;

let controller;

/**
 * Dashboard Timetable
 */
class Timetable extends Component {
    // State
    state = {
        modalTimetable: {
            show: false,
            toggle: () => this.setState({ modalTimetable: { ...this.state.modalTimetable, show: !this.state.modalTimetable.show } })
        },
        timetable: [],
        weekdays: [
            'Monday',
            'Tuesday',
            'Wednesday',
            'Thursday',
            'Friday',
            'Saturday',
            'Sunday',
        ],
        selectedDay: moment().format('dddd'),
        selectedDate: moment().format('YYYY-MM-DD'),
    };

    /**
     * Component Did Update
     */
    componentDidMount() {
        this.getTimetable();
    }

    /**
     * Component Did Update
     */
    componentDidUpdate(prevProps, prevState) {
        const { selectedChild } = this.props;
        const { selectedDay, selectedDate } = this.state;

        if (
            prevState.selectedDay !== selectedDay ||
            prevProps.selectedChild.class_id !== selectedChild.class_id
        ) {
            this.setState({ timetable: [] });
            this.getTimetable(selectedDay, selectedDate);
        }
    }

    /**
     * Get Timetable
     * @param {string} dayname Name of the day
     * @param {string} thatDate Date (YYYY-MM-DD)
     */
    getTimetable = async (
        dayname = moment().format('dddd'),
        thatDate = moment().format('YYYY-MM-DD')
    ) => {

        let weekend_days = this.props.authData.centerData.weekend_days.split(',')
        if (weekend_days.includes(dayname.toLowerCase())) {
            // console.log('ererer');
            this.setState({
                timetable: null,
                selectedDay: dayname,
            });
            return
        }

        const { authData, selectedChild } = this.props;
        const { class_id, agegroup_id, class_theme } = selectedChild;
        const { center_id } = authData.centerData;
        const { auth_key } = authData.loginData;

        const params = {
            class_id,
            agegroup_id,
            class_theme,
            dayname,
            thatDate,
        };

        if (controller) controller.abort();
        controller = new AbortController();

        try {
            const res = await GET('dashboard/get-timetable', {
                params,
                signal: controller.signal,
            });

            this.setState({
                timetable: res.data.data.length > 0 ? res.data.data : null,
                selectedDay: dayname,
            });
        } catch (err) {
            if (axios.isCancel(err)) {
                // console.log("axiosGET request cancelled", error.message, global.baseUrl + controllerURL);
            }
            toast.error('Something went wrong while fetching timetable!');
            // console.log(err);
        }
    };

    /**
     * Render Weekdays Buttons
     * @returns {HTMLElement} Outputs the buttons of weekdays
     */
    renderWeekdayButtons = () => {
        const { weekdays, selectedDay } = this.state;
        let weekend_days = this.props.authData.centerData.weekend_days.split(',')
        const weekdayButtons = weekdays.map((item, index) => {
            if (!weekend_days.includes(item.toLowerCase())) {
                return (<div key={index} style={{ backgroundColor: (selectedDay == item) ? Blueberry : ChristmasWhite, color: (selectedDay == item) ? White : Black, padding: '5px 10px', borderRadius: 10, fontSize: 11 }} className='d-flex flex-row align-items-center me-1 mb-1 cursor-pointer' onClick={() =>
                    this.handleDayDate(
                        item,
                        moment(moment().startOf('isoweek'))
                            .add(index, 'd')
                            .format('YYYY-MM-DD')
                    )
                }>
                    {moment(item, "dddd").format('ddd')}
                </div>
                );
            }
        });
        return weekdayButtons;
    };


    /**
     * Handle Day & Date Selection
     * @param {string} selectedDay Day name of the week
     * @param {string} selectedDate Date (YYYY-MM-DD)
     */
    handleDayDate = (selectedDay, selectedDate) => {
        this.setState({
            selectedDay,
            selectedDate,
        });
    };

    /**
     * Render Component
     * @returns {HTMLElement}
     */
    render() {
        // State
        const { lang_orientation: dir } = this.props.defaultLanguage;
        const { timetable, modalTimetable } = this.state;
        return (<>
            <Card style={{ borderRadius: 20, borderWidth: 0, height: '100%' }}>
                <Card.Body className='p-3'>
                    <div>
                        <div className='d-flex flex-row align-items-center justify-content-between'>
                            <div className='d-flex flex-row flex-wrap align-items-center' style={{ flex: 1 }}>
                                {this.renderWeekdayButtons()}
                            </div>
                            <div className='cursor-pointer' onClick={() => modalTimetable.toggle()}>
                                <GetIcon icon="LuExternalLink" style={{ color: BlueCrayola }} />
                            </div>
                        </div>
                    </div>
                    {timetable !== null && timetable.length > 0 ? (
                        <div className='d-flex flex-column mt-2' style={{ width: '100%', border: 'solid 1px ' + LightGray, borderRadius: 5 }}>
                            {timetable.map((item, index) => {

                                const cc = new ContrastColor({
                                    bgColor: item.as_color,
                                    threshold: 200,
                                });
                                const defaultFgColor = cc.contrastColor();

                                return <div style={{ fontSize: 11, borderBottom: 'solid 1px ' + LightGray, borderBottomWidth: (index == timetable.length - 1) ? 0 : 1 }} className='d-flex flex-row'>
                                    <div style={{ flex: 1, borderRight: 'solid 1px ' + LightGray, backgroundColor: (item.acs_name) ? 'initial' : SeashellPink }} className='d-flex flex-column justify-content-center align-items-center p-2'>
                                        <div>
                                            {moment(item.time_start, 'HH:mm:ss').format('HH:mm') + '-' + moment(item.time_end, 'HH:mm:ss').format('HH:mm')}
                                        </div>
                                        <div>
                                            {item.tp_type_name &&
                                                <span style={{ borderColor: item.tp_type_color, borderWidth: 1, borderStyle: 'solid', color: item.tp_type_color, textTransform: 'uppercase', borderRadius: 5, paddingInline: 4, paddingBlock: 2, display: 'inline-block' }}>
                                                    {item.tp_type_name}
                                                </span>
                                            }
                                        </div>
                                    </div>
                                    <div style={{ flex: 1, backgroundColor: (item.acs_name) ? 'initial' : SeashellPink }} className='px-2 d-flex flex-column justify-content-center p-2'>
                                        {(!item.acs_name)
                                            ? <div style={{ color: CerisePink }}>{t('Free')}</div>
                                            : <div className='d-flex flex-row align-items-center justify-content-between p-2' style={{ backgroundColor: item.as_color, borderColor: item.as_color, color: defaultFgColor, borderRadius: 5 }}>
                                                <div style={{ fontWeight: 'bold' }}>{item.acs_name}</div>
                                                {/* {item.activeLessons.map(
                                                                    (lesson_item, index) => (
                                                                        <Dropdown.Item
                                                                            key={index}
                                                                            as='div'
                                                                            style={{
                                                                            }}>
                                                                            <Link
                                                                                to={'/lesson-details/' + lesson_item.asl_id
                                                                                }
                                                                                className='dropdown-item'>
                                                                                {lesson_item.asl_name}
                                                                            </Link>
                                                                        </Dropdown.Item>
                                                                    )
                                                                )} */}
                                                {item.class_online_url !== null && (
                                                    <div onClick={() => window.open(item.class_online_url, '_blank', 'noopener,noreferrer')} className='cursor-pointer'>
                                                        <FontAwesomeIcon icon={faGlobe} color={defaultFgColor} />
                                                    </div>
                                                )}
                                            </div>
                                        }
                                    </div>
                                </div>
                            })}
                        </div>
                    ) : (
                        <div
                            style={{
                                height: '89px',
                                flexDirection: 'column',
                            }}
                            className='d-flex justify-content-center align-items-center'>
                            {timetable !== null ? (
                                <>
                                    <span className='mb-1'>
                                        <Spinner animation='grow' variant='dark' />
                                    </span>
                                    {t('Fetching timetable...')}
                                </>
                            ) : (
                                <> {t('No timetable found!')}</>
                            )}
                        </div>
                    )}
                </Card.Body>
            </Card>
            <Modal size="xl" show={modalTimetable.show} onHide={() => modalTimetable.toggle()}>
                <Modal.Header closeButton>
                    <Modal.Title>{t('Timetable')}</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <TimetableComplete />
                </Modal.Body>
            </Modal>
        </>);
    }
}

const mapStateToProps = (state) => ({
    authData: state.auth.authData,
    selectedChild: state.selectedChild.data,
    languages: state.language.languages,
    defaultLanguage: state.language.defaultLanguage,
});

export default connect(mapStateToProps, null)(Timetable);
